/* THIS IS A GENERATED FILE. PLEASE DO NOT MODIFY!! */
import * as Types from '../../../../types/dashboard-core-gqlTypes.generated.d';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions =  {}
export type BankAccountWithInstitutionAndOwnerFragmentGQLType = (
  { __typename?: 'BankAccountWithInstitutionAndOwner' }
  & Pick<Types.BankAccountWithInstitutionAndOwnerGQLType, 'id' | 'accountNumber' | 'currencyCode' | 'name' | 'bankInstitutionId' | 'plaidAccountId' | 'retrievedAt' | 'current' | 'available' | 'conversionRate' | 'routingNumber' | 'institutionName' | 'bankInstitutionKey' | 'organizationId' | 'ownerType' | 'ownerName' | 'connectionProviderName' | 'connectionProviderAccountMask'>
);

export type GetInstitutionAndConnectionDetailsForBorrowerIdQueryVariablesGQLType = Types.Exact<{
  borrowerId: Types.Scalars['UUID'];
}>;


export type GetInstitutionAndConnectionDetailsForBorrowerIdQueryGQLType = (
  { __typename?: 'Query' }
  & { institutionAndConnectionDetailsForBorrower: Array<(
    { __typename?: 'CreditFacilityWithInstitutionsAndConnections' }
    & Pick<Types.CreditFacilityWithInstitutionsAndConnectionsGQLType, 'creditFacilityId' | 'creditFacilitySlug' | 'creditFacilityName' | 'plaidBankInstitutionId' | 'plaidBankInstitutionName' | 'plaidBankInstitutionKey' | 'plaidItemId' | 'plaidAccountId' | 'plaidAccountName' | 'plaidAccountMask'>
    & { organizations: Array<(
      { __typename?: 'Organization' }
      & Pick<Types.OrganizationGQLType, 'id' | 'name' | 'slug' | 'type'>
    )> }
  )> }
);

export type GetInstitutionAndConnectionDetailsForImplementationIdQueryVariablesGQLType = Types.Exact<{
  implementationId: Types.Scalars['UUID'];
}>;


export type GetInstitutionAndConnectionDetailsForImplementationIdQueryGQLType = (
  { __typename?: 'Query' }
  & { institutionAndConnectionDetailsForImplementation: Array<(
    { __typename?: 'CreditFacilityWithInstitutionsAndConnections' }
    & Pick<Types.CreditFacilityWithInstitutionsAndConnectionsGQLType, 'creditFacilityId' | 'creditFacilitySlug' | 'creditFacilityName' | 'plaidBankInstitutionId' | 'plaidBankInstitutionName' | 'plaidBankInstitutionKey' | 'plaidItemId' | 'plaidAccountId' | 'plaidAccountName' | 'plaidAccountMask'>
    & { organizations: Array<(
      { __typename?: 'Organization' }
      & Pick<Types.OrganizationGQLType, 'id' | 'name' | 'slug' | 'type'>
    )> }
  )> }
);

export type GetBankAccountsByCreditFacilityIdQueryVariablesGQLType = Types.Exact<{
  organizationId: Types.Scalars['UUID'];
  creditFacilityId: Types.Scalars['UUID'];
}>;


export type GetBankAccountsByCreditFacilityIdQueryGQLType = (
  { __typename?: 'Query' }
  & { bankAccountsWithDesignationAndOwner: Array<(
    { __typename?: 'BankAccountWithInstitutionDesignationAndOwner' }
    & Pick<Types.BankAccountWithInstitutionDesignationAndOwnerGQLType, 'id' | 'accountNumber' | 'currencyCode' | 'name' | 'bankInstitutionId' | 'plaidAccountId' | 'retrievedAt' | 'current' | 'available' | 'conversionRate' | 'routingNumber' | 'institutionName' | 'bankInstitutionKey' | 'organizationId' | 'ownerType' | 'accountType' | 'creditFacilityId' | 'ownerName' | 'connectionProviderName' | 'connectionProviderAccountMask'>
  )> }
);

export type GetAllBankInstitutionsQueryVariablesGQLType = Types.Exact<{ [key: string]: never; }>;


export type GetAllBankInstitutionsQueryGQLType = (
  { __typename?: 'Query' }
  & { allBankInstitutions: Array<(
    { __typename?: 'BankInstitution' }
    & Pick<Types.BankInstitutionGQLType, 'id' | 'name' | 'bankInstitutionKey' | 'plaidInstitutionId'>
  )> }
);

export type GetBankAccountsWithInstitutionAndOwnerByImplementationIdQueryVariablesGQLType = Types.Exact<{
  implementationId: Types.Scalars['UUID'];
  maskSensitiveInfo?: Types.Maybe<Types.Scalars['Boolean']>;
}>;


export type GetBankAccountsWithInstitutionAndOwnerByImplementationIdQueryGQLType = (
  { __typename?: 'Query' }
  & { implementation: (
    { __typename?: 'Implementation' }
    & { bankAccountsWithInstitutionAndOwner: Array<(
      { __typename?: 'BankAccountWithInstitutionAndOwner' }
      & BankAccountWithInstitutionAndOwnerFragmentGQLType
    )> }
  ) }
);

export type AddBankAccountMutationVariablesGQLType = Types.Exact<{
  bankInstitutionId: Types.Scalars['UUID'];
  accountName: Types.Scalars['String'];
  accountNumber: Types.Scalars['String'];
  routingNumber: Types.Scalars['String'];
  implementationId: Types.Scalars['UUID'];
  ownerId: Types.Scalars['UUID'];
  plaidAccountId?: Types.Maybe<Types.Scalars['String']>;
}>;


export type AddBankAccountMutationGQLType = (
  { __typename?: 'Mutation' }
  & { addBankAccount: (
    { __typename?: 'ResponseWithString' }
    & Pick<Types.ResponseWithStringGQLType, 'response'>
  ) }
);

export type EditBankAccountMutationVariablesGQLType = Types.Exact<{
  bankAccountId: Types.Scalars['UUID'];
  accountName: Types.Scalars['String'];
  ownerId: Types.Scalars['UUID'];
  plaidAccountId?: Types.Maybe<Types.Scalars['String']>;
}>;


export type EditBankAccountMutationGQLType = (
  { __typename?: 'Mutation' }
  & { editBankAccount: (
    { __typename?: 'ResponseWithString' }
    & Pick<Types.ResponseWithStringGQLType, 'response'>
  ) }
);

export type DeactivateBankAccountMutationVariablesGQLType = Types.Exact<{
  bankAccountId: Types.Scalars['UUID'];
}>;


export type DeactivateBankAccountMutationGQLType = (
  { __typename?: 'Mutation' }
  & { deactivateBankAccount: (
    { __typename?: 'ResponseWithString' }
    & Pick<Types.ResponseWithStringGQLType, 'response'>
  ) }
);

export const BankAccountWithInstitutionAndOwnerFragmentDocGQLType = gql`
    fragment BankAccountWithInstitutionAndOwner on BankAccountWithInstitutionAndOwner {
  id
  accountNumber
  currencyCode
  name
  bankInstitutionId
  plaidAccountId
  retrievedAt
  current
  available
  conversionRate
  routingNumber
  institutionName
  bankInstitutionKey
  organizationId
  ownerType
  ownerName
  connectionProviderName
  connectionProviderAccountMask
}
    `;
export const GetInstitutionAndConnectionDetailsForBorrowerIdDocumentGQLType = gql`
    query GetInstitutionAndConnectionDetailsForBorrowerId($borrowerId: UUID!) {
  institutionAndConnectionDetailsForBorrower(borrowerId: $borrowerId) {
    creditFacilityId
    creditFacilitySlug
    creditFacilityName
    organizations {
      id
      name
      slug
      type
    }
    plaidBankInstitutionId
    plaidBankInstitutionName
    plaidBankInstitutionKey
    plaidItemId
    plaidAccountId
    plaidAccountName
    plaidAccountMask
  }
}
    `;

/**
 * __useGetInstitutionAndConnectionDetailsForBorrowerIdQuery__
 *
 * To run a query within a React component, call `useGetInstitutionAndConnectionDetailsForBorrowerIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetInstitutionAndConnectionDetailsForBorrowerIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetInstitutionAndConnectionDetailsForBorrowerIdQuery({
 *   variables: {
 *      borrowerId: // value for 'borrowerId'
 *   },
 * });
 */
export function useGetInstitutionAndConnectionDetailsForBorrowerIdQuery(baseOptions: Apollo.QueryHookOptions<GetInstitutionAndConnectionDetailsForBorrowerIdQueryGQLType, GetInstitutionAndConnectionDetailsForBorrowerIdQueryVariablesGQLType>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetInstitutionAndConnectionDetailsForBorrowerIdQueryGQLType, GetInstitutionAndConnectionDetailsForBorrowerIdQueryVariablesGQLType>(GetInstitutionAndConnectionDetailsForBorrowerIdDocumentGQLType, options);
      }
export function useGetInstitutionAndConnectionDetailsForBorrowerIdLazyQueryGQLType(baseOptions?: Apollo.LazyQueryHookOptions<GetInstitutionAndConnectionDetailsForBorrowerIdQueryGQLType, GetInstitutionAndConnectionDetailsForBorrowerIdQueryVariablesGQLType>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetInstitutionAndConnectionDetailsForBorrowerIdQueryGQLType, GetInstitutionAndConnectionDetailsForBorrowerIdQueryVariablesGQLType>(GetInstitutionAndConnectionDetailsForBorrowerIdDocumentGQLType, options);
        }
export type GetInstitutionAndConnectionDetailsForBorrowerIdQueryHookResult = ReturnType<typeof useGetInstitutionAndConnectionDetailsForBorrowerIdQuery>;
export type GetInstitutionAndConnectionDetailsForBorrowerIdLazyQueryGQLTypeHookResult = ReturnType<typeof useGetInstitutionAndConnectionDetailsForBorrowerIdLazyQueryGQLType>;
export type GetInstitutionAndConnectionDetailsForBorrowerIdQueryResultGQLType = Apollo.QueryResult<GetInstitutionAndConnectionDetailsForBorrowerIdQueryGQLType, GetInstitutionAndConnectionDetailsForBorrowerIdQueryVariablesGQLType>;
export const GetInstitutionAndConnectionDetailsForImplementationIdDocumentGQLType = gql`
    query GetInstitutionAndConnectionDetailsForImplementationId($implementationId: UUID!) {
  institutionAndConnectionDetailsForImplementation(
    implementationId: $implementationId
  ) {
    creditFacilityId
    creditFacilitySlug
    creditFacilityName
    organizations {
      id
      name
      slug
      type
    }
    plaidBankInstitutionId
    plaidBankInstitutionName
    plaidBankInstitutionKey
    plaidItemId
    plaidAccountId
    plaidAccountName
    plaidAccountMask
  }
}
    `;

/**
 * __useGetInstitutionAndConnectionDetailsForImplementationIdQuery__
 *
 * To run a query within a React component, call `useGetInstitutionAndConnectionDetailsForImplementationIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetInstitutionAndConnectionDetailsForImplementationIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetInstitutionAndConnectionDetailsForImplementationIdQuery({
 *   variables: {
 *      implementationId: // value for 'implementationId'
 *   },
 * });
 */
export function useGetInstitutionAndConnectionDetailsForImplementationIdQuery(baseOptions: Apollo.QueryHookOptions<GetInstitutionAndConnectionDetailsForImplementationIdQueryGQLType, GetInstitutionAndConnectionDetailsForImplementationIdQueryVariablesGQLType>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetInstitutionAndConnectionDetailsForImplementationIdQueryGQLType, GetInstitutionAndConnectionDetailsForImplementationIdQueryVariablesGQLType>(GetInstitutionAndConnectionDetailsForImplementationIdDocumentGQLType, options);
      }
export function useGetInstitutionAndConnectionDetailsForImplementationIdLazyQueryGQLType(baseOptions?: Apollo.LazyQueryHookOptions<GetInstitutionAndConnectionDetailsForImplementationIdQueryGQLType, GetInstitutionAndConnectionDetailsForImplementationIdQueryVariablesGQLType>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetInstitutionAndConnectionDetailsForImplementationIdQueryGQLType, GetInstitutionAndConnectionDetailsForImplementationIdQueryVariablesGQLType>(GetInstitutionAndConnectionDetailsForImplementationIdDocumentGQLType, options);
        }
export type GetInstitutionAndConnectionDetailsForImplementationIdQueryHookResult = ReturnType<typeof useGetInstitutionAndConnectionDetailsForImplementationIdQuery>;
export type GetInstitutionAndConnectionDetailsForImplementationIdLazyQueryGQLTypeHookResult = ReturnType<typeof useGetInstitutionAndConnectionDetailsForImplementationIdLazyQueryGQLType>;
export type GetInstitutionAndConnectionDetailsForImplementationIdQueryResultGQLType = Apollo.QueryResult<GetInstitutionAndConnectionDetailsForImplementationIdQueryGQLType, GetInstitutionAndConnectionDetailsForImplementationIdQueryVariablesGQLType>;
export const GetBankAccountsByCreditFacilityIdDocumentGQLType = gql`
    query GetBankAccountsByCreditFacilityId($organizationId: UUID!, $creditFacilityId: UUID!) {
  bankAccountsWithDesignationAndOwner(
    organizationId: $organizationId
    creditFacilityId: $creditFacilityId
  ) {
    id
    accountNumber
    currencyCode
    name
    bankInstitutionId
    plaidAccountId
    retrievedAt
    current
    available
    conversionRate
    routingNumber
    institutionName
    bankInstitutionKey
    organizationId
    ownerType
    accountType
    creditFacilityId
    ownerName
    connectionProviderName
    connectionProviderAccountMask
  }
}
    `;

/**
 * __useGetBankAccountsByCreditFacilityIdQuery__
 *
 * To run a query within a React component, call `useGetBankAccountsByCreditFacilityIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBankAccountsByCreditFacilityIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBankAccountsByCreditFacilityIdQuery({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *      creditFacilityId: // value for 'creditFacilityId'
 *   },
 * });
 */
export function useGetBankAccountsByCreditFacilityIdQuery(baseOptions: Apollo.QueryHookOptions<GetBankAccountsByCreditFacilityIdQueryGQLType, GetBankAccountsByCreditFacilityIdQueryVariablesGQLType>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetBankAccountsByCreditFacilityIdQueryGQLType, GetBankAccountsByCreditFacilityIdQueryVariablesGQLType>(GetBankAccountsByCreditFacilityIdDocumentGQLType, options);
      }
export function useGetBankAccountsByCreditFacilityIdLazyQueryGQLType(baseOptions?: Apollo.LazyQueryHookOptions<GetBankAccountsByCreditFacilityIdQueryGQLType, GetBankAccountsByCreditFacilityIdQueryVariablesGQLType>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetBankAccountsByCreditFacilityIdQueryGQLType, GetBankAccountsByCreditFacilityIdQueryVariablesGQLType>(GetBankAccountsByCreditFacilityIdDocumentGQLType, options);
        }
export type GetBankAccountsByCreditFacilityIdQueryHookResult = ReturnType<typeof useGetBankAccountsByCreditFacilityIdQuery>;
export type GetBankAccountsByCreditFacilityIdLazyQueryGQLTypeHookResult = ReturnType<typeof useGetBankAccountsByCreditFacilityIdLazyQueryGQLType>;
export type GetBankAccountsByCreditFacilityIdQueryResultGQLType = Apollo.QueryResult<GetBankAccountsByCreditFacilityIdQueryGQLType, GetBankAccountsByCreditFacilityIdQueryVariablesGQLType>;
export const GetAllBankInstitutionsDocumentGQLType = gql`
    query GetAllBankInstitutions {
  allBankInstitutions {
    id
    name
    bankInstitutionKey
    plaidInstitutionId
  }
}
    `;

/**
 * __useGetAllBankInstitutionsQuery__
 *
 * To run a query within a React component, call `useGetAllBankInstitutionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllBankInstitutionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllBankInstitutionsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAllBankInstitutionsQuery(baseOptions?: Apollo.QueryHookOptions<GetAllBankInstitutionsQueryGQLType, GetAllBankInstitutionsQueryVariablesGQLType>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAllBankInstitutionsQueryGQLType, GetAllBankInstitutionsQueryVariablesGQLType>(GetAllBankInstitutionsDocumentGQLType, options);
      }
export function useGetAllBankInstitutionsLazyQueryGQLType(baseOptions?: Apollo.LazyQueryHookOptions<GetAllBankInstitutionsQueryGQLType, GetAllBankInstitutionsQueryVariablesGQLType>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAllBankInstitutionsQueryGQLType, GetAllBankInstitutionsQueryVariablesGQLType>(GetAllBankInstitutionsDocumentGQLType, options);
        }
export type GetAllBankInstitutionsQueryHookResult = ReturnType<typeof useGetAllBankInstitutionsQuery>;
export type GetAllBankInstitutionsLazyQueryGQLTypeHookResult = ReturnType<typeof useGetAllBankInstitutionsLazyQueryGQLType>;
export type GetAllBankInstitutionsQueryResultGQLType = Apollo.QueryResult<GetAllBankInstitutionsQueryGQLType, GetAllBankInstitutionsQueryVariablesGQLType>;
export const GetBankAccountsWithInstitutionAndOwnerByImplementationIdDocumentGQLType = gql`
    query getBankAccountsWithInstitutionAndOwnerByImplementationId($implementationId: UUID!, $maskSensitiveInfo: Boolean) {
  implementation(implementationId: $implementationId) {
    bankAccountsWithInstitutionAndOwner(maskSensitiveInfo: $maskSensitiveInfo) {
      ...BankAccountWithInstitutionAndOwner
    }
  }
}
    ${BankAccountWithInstitutionAndOwnerFragmentDocGQLType}`;

/**
 * __useGetBankAccountsWithInstitutionAndOwnerByImplementationIdQuery__
 *
 * To run a query within a React component, call `useGetBankAccountsWithInstitutionAndOwnerByImplementationIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBankAccountsWithInstitutionAndOwnerByImplementationIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBankAccountsWithInstitutionAndOwnerByImplementationIdQuery({
 *   variables: {
 *      implementationId: // value for 'implementationId'
 *      maskSensitiveInfo: // value for 'maskSensitiveInfo'
 *   },
 * });
 */
export function useGetBankAccountsWithInstitutionAndOwnerByImplementationIdQuery(baseOptions: Apollo.QueryHookOptions<GetBankAccountsWithInstitutionAndOwnerByImplementationIdQueryGQLType, GetBankAccountsWithInstitutionAndOwnerByImplementationIdQueryVariablesGQLType>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetBankAccountsWithInstitutionAndOwnerByImplementationIdQueryGQLType, GetBankAccountsWithInstitutionAndOwnerByImplementationIdQueryVariablesGQLType>(GetBankAccountsWithInstitutionAndOwnerByImplementationIdDocumentGQLType, options);
      }
export function useGetBankAccountsWithInstitutionAndOwnerByImplementationIdLazyQueryGQLType(baseOptions?: Apollo.LazyQueryHookOptions<GetBankAccountsWithInstitutionAndOwnerByImplementationIdQueryGQLType, GetBankAccountsWithInstitutionAndOwnerByImplementationIdQueryVariablesGQLType>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetBankAccountsWithInstitutionAndOwnerByImplementationIdQueryGQLType, GetBankAccountsWithInstitutionAndOwnerByImplementationIdQueryVariablesGQLType>(GetBankAccountsWithInstitutionAndOwnerByImplementationIdDocumentGQLType, options);
        }
export type GetBankAccountsWithInstitutionAndOwnerByImplementationIdQueryHookResult = ReturnType<typeof useGetBankAccountsWithInstitutionAndOwnerByImplementationIdQuery>;
export type GetBankAccountsWithInstitutionAndOwnerByImplementationIdLazyQueryGQLTypeHookResult = ReturnType<typeof useGetBankAccountsWithInstitutionAndOwnerByImplementationIdLazyQueryGQLType>;
export type GetBankAccountsWithInstitutionAndOwnerByImplementationIdQueryResultGQLType = Apollo.QueryResult<GetBankAccountsWithInstitutionAndOwnerByImplementationIdQueryGQLType, GetBankAccountsWithInstitutionAndOwnerByImplementationIdQueryVariablesGQLType>;
export const AddBankAccountDocumentGQLType = gql`
    mutation AddBankAccount($bankInstitutionId: UUID!, $accountName: String!, $accountNumber: String!, $routingNumber: String!, $implementationId: UUID!, $ownerId: UUID!, $plaidAccountId: String) {
  addBankAccount(
    bankInstitutionId: $bankInstitutionId
    accountName: $accountName
    accountNumber: $accountNumber
    routingNumber: $routingNumber
    implementationId: $implementationId
    ownerId: $ownerId
    plaidAccountId: $plaidAccountId
  ) {
    response
  }
}
    `;
export type AddBankAccountMutationFnGQLType = Apollo.MutationFunction<AddBankAccountMutationGQLType, AddBankAccountMutationVariablesGQLType>;

/**
 * __useAddBankAccountMutation__
 *
 * To run a mutation, you first call `useAddBankAccountMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddBankAccountMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addBankAccountMutation, { data, loading, error }] = useAddBankAccountMutation({
 *   variables: {
 *      bankInstitutionId: // value for 'bankInstitutionId'
 *      accountName: // value for 'accountName'
 *      accountNumber: // value for 'accountNumber'
 *      routingNumber: // value for 'routingNumber'
 *      implementationId: // value for 'implementationId'
 *      ownerId: // value for 'ownerId'
 *      plaidAccountId: // value for 'plaidAccountId'
 *   },
 * });
 */
export function useAddBankAccountMutation(baseOptions?: Apollo.MutationHookOptions<AddBankAccountMutationGQLType, AddBankAccountMutationVariablesGQLType>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddBankAccountMutationGQLType, AddBankAccountMutationVariablesGQLType>(AddBankAccountDocumentGQLType, options);
      }
export type AddBankAccountMutationHookResult = ReturnType<typeof useAddBankAccountMutation>;
export type AddBankAccountMutationResultGQLType = Apollo.MutationResult<AddBankAccountMutationGQLType>;
export type AddBankAccountMutationOptionsGQLType = Apollo.BaseMutationOptions<AddBankAccountMutationGQLType, AddBankAccountMutationVariablesGQLType>;
export const EditBankAccountDocumentGQLType = gql`
    mutation EditBankAccount($bankAccountId: UUID!, $accountName: String!, $ownerId: UUID!, $plaidAccountId: String) {
  editBankAccount(
    bankAccountId: $bankAccountId
    accountName: $accountName
    ownerId: $ownerId
    plaidAccountId: $plaidAccountId
  ) {
    response
  }
}
    `;
export type EditBankAccountMutationFnGQLType = Apollo.MutationFunction<EditBankAccountMutationGQLType, EditBankAccountMutationVariablesGQLType>;

/**
 * __useEditBankAccountMutation__
 *
 * To run a mutation, you first call `useEditBankAccountMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditBankAccountMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editBankAccountMutation, { data, loading, error }] = useEditBankAccountMutation({
 *   variables: {
 *      bankAccountId: // value for 'bankAccountId'
 *      accountName: // value for 'accountName'
 *      ownerId: // value for 'ownerId'
 *      plaidAccountId: // value for 'plaidAccountId'
 *   },
 * });
 */
export function useEditBankAccountMutation(baseOptions?: Apollo.MutationHookOptions<EditBankAccountMutationGQLType, EditBankAccountMutationVariablesGQLType>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EditBankAccountMutationGQLType, EditBankAccountMutationVariablesGQLType>(EditBankAccountDocumentGQLType, options);
      }
export type EditBankAccountMutationHookResult = ReturnType<typeof useEditBankAccountMutation>;
export type EditBankAccountMutationResultGQLType = Apollo.MutationResult<EditBankAccountMutationGQLType>;
export type EditBankAccountMutationOptionsGQLType = Apollo.BaseMutationOptions<EditBankAccountMutationGQLType, EditBankAccountMutationVariablesGQLType>;
export const DeactivateBankAccountDocumentGQLType = gql`
    mutation DeactivateBankAccount($bankAccountId: UUID!) {
  deactivateBankAccount(bankAccountId: $bankAccountId) {
    response
  }
}
    `;
export type DeactivateBankAccountMutationFnGQLType = Apollo.MutationFunction<DeactivateBankAccountMutationGQLType, DeactivateBankAccountMutationVariablesGQLType>;

/**
 * __useDeactivateBankAccountMutation__
 *
 * To run a mutation, you first call `useDeactivateBankAccountMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeactivateBankAccountMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deactivateBankAccountMutation, { data, loading, error }] = useDeactivateBankAccountMutation({
 *   variables: {
 *      bankAccountId: // value for 'bankAccountId'
 *   },
 * });
 */
export function useDeactivateBankAccountMutation(baseOptions?: Apollo.MutationHookOptions<DeactivateBankAccountMutationGQLType, DeactivateBankAccountMutationVariablesGQLType>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeactivateBankAccountMutationGQLType, DeactivateBankAccountMutationVariablesGQLType>(DeactivateBankAccountDocumentGQLType, options);
      }
export type DeactivateBankAccountMutationHookResult = ReturnType<typeof useDeactivateBankAccountMutation>;
export type DeactivateBankAccountMutationResultGQLType = Apollo.MutationResult<DeactivateBankAccountMutationGQLType>;
export type DeactivateBankAccountMutationOptionsGQLType = Apollo.BaseMutationOptions<DeactivateBankAccountMutationGQLType, DeactivateBankAccountMutationVariablesGQLType>;